import React from 'react';
import { ReactComponent as NoVideoIconSvg } from '../../../resources/icons/no-video.svg';
import { EmptyContainer, IconContainer, TextContainer } from './CameraCardPlaceholderLoading';
export var OfflinePlaceholder = function () {
    return (React.createElement(EmptyContainer, null,
        React.createElement(IconContainer, null,
            React.createElement(NoVideoIconSvg, null)),
        React.createElement(TextContainer, null, "Camera offline")));
};
//# sourceMappingURL=CameraCardPlaceholderOffline.js.map